import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';

const ShowFault = ({ fault }) => {
  if (fault <= 0) {
    return null
  }
  return (
    <div className="new-fleet-info__train__header__events--warning" >
      <span>Warnings</span>
      <div className="new-fleet-info__train__header__events--circle new-fleet-info__status-orange">
        <span>{fault}</span>
      </div>
    </div>
  )
}
export default ShowFault